import { AccountCategory, ScheduleVendorAcctCategoryAssoc, Vendor } from "./index";

export class ScheduleTradePartnerView {
    jobId: number;
    scheduleAccountCategory: AccountCategory;
    templateVendor: Vendor;
    scheduleVendorAcctCategoryAssoc: ScheduleVendorAcctCategoryAssoc;
    sentForPayment: boolean;
}